import { useEffect, useState } from 'react';

import { Accordion } from 'flowbite';
import type { AccordionOptions, AccordionItem, AccordionInterface } from 'flowbite';
import { useTranslation } from 'next-i18next';

import { IAnyType } from 'common/types/common';
import { IFaqItemType } from '.';

export const useHook = ({ content }: { content: IFaqItemType[] }) => {
  const { t } = useTranslation('common');

  const [activeElements, setActiveElements] = useState<string[]>([]);
  const [initialized, setInitialized] = useState<boolean>(false);

  const handleClick = (value: string) => () => {
    setActiveElements(prev => {
      if (prev.includes(value)) {
        return prev.filter(item => item !== value);
      }
      return [...prev, value];
    });
  };

  useEffect(() => {
    const element = document.querySelector('#accordion-collapse-heading-1');
    if (!initialized && element) {
      // create an array of objects with the id, trigger element (eg. button), and the content element
      const accordionItems: AccordionItem[] = content.map((_: IAnyType, index: number) => {
        const item = index + 1;
        return {
          id: `accordion-collapse-heading-${item}`,
          triggerEl: document.querySelector(`#accordion-collapse-heading-${item}`) as IAnyType,
          targetEl: document.querySelector(`#accordion-collapse-body-${item}`) as IAnyType,
          active: false,
        };
      });
      const accordionElement: IAnyType = document.querySelector('#accordion-collapse') as IAnyType;
      const options: AccordionOptions = {
        alwaysOpen: true,
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const accordion: AccordionInterface = new Accordion(
        accordionElement,
        accordionItems,
        options,
      );
      setInitialized(true);
    }
  }, [initialized, t]);

  return { activeElements, handleClick };
};
